<template>
  <p class="ParagraphBlock"
     :class="{'bold': bold}"><slot></slot></p>
</template>

<script>
  export default {
    props: {
      bold: {
        required: false,
        type: Boolean
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .ParagraphBlock {
    font-size: 18px;
    font-weight: 500;

    &.bold {
      font-size: 20px;
      font-weight: 700;
    }
  }
</style>
